<script setup lang="ts">
import type { TpgSelectEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';
import { computed } from 'vue';

import { omit } from '@nora-monorepo/shared';

export interface GrammarMenuItemProps {
  label?: string;
  value?: string;
  badgeValue?: string;
  secondaryLabel?: string;
  type?: 'default' | 'error';
  leadingIconTemplate?: IconConstant | '';
  overrideLeadingIconTemplateColor?: string;
  secondaryLeadingIconTemplate?: IconConstant | '';
  trailingIconTemplate?: IconConstant | '';
  secondaryTrailingIconTemplate?: IconConstant | '';
  disabled?: boolean;
  selected?: boolean;

  onSelect?: (event: TpgSelectEvent) => void;
}

const props = withDefaults(defineProps<GrammarMenuItemProps>(), {
  label: '',
  value: '',
  badgeValue: '',
  secondaryLabel: '',
  type: 'default',
  leadingIconTemplate: '',
  overrideLeadingIconTemplateColor: '',
  secondaryLeadingIconTemplate: '',
  trailingIconTemplate: '',
  secondaryTrailingIconTemplate: '',
  disabled: false,
  selected: false,
  onSelect: undefined,
});

const emit = defineEmits(['select']);

const slots = defineSlots<GrammarMenuItemSlots>();

interface GrammarMenuItemSlots {
  badge?: Slot;
  content?: Slot;
}

function onSelect(event: TpgSelectEvent) {
  if (props.onSelect) {
    props.onSelect(event);

    return;
  }

  emit('select', event);
}

const webComponentProps = computed(() => {
  return omit(props, ['onSelect']);
});
</script>

<template>
  <tpg-menu-item v-bind="webComponentProps" @tpg-select="onSelect">
    <div
      v-if="slots.badge"
      slot="badge"
      class="inline-flex"
    >
      <slot name="badge" />
    </div>

    <div
      v-if="slots.content"
      slot="content"
      class="inline-flex"
    >
      <slot name="content" />
    </div>
  </tpg-menu-item>
</template>
